import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = [
    'select',
    'warning',
    'inlineWarning',
    'moveBody',
    'removeBody',
    'destinationName',
    'currentName',
    'memberCount',
    'missingCount',
    'missingList',
    'missingDestinationName',
    'missingDestinationNameRepeat',
    'membershipWarning',
  ];

  static values = {
    missingMembers: Object,
    currentId: String,
    currentName: String,
    memberCount: Number,
  };

  preview(event) {
    // the new fundraiser form has no team to move yet
    if (!this.hasWarningTarget) return;

    const selected = this.selectTarget.value;

    if (selected === this.currentIdValue) {
      this.inlineWarningTarget.classList.add('hidden');
      return;
    }

    if (selected) {
      this.previewMove(selected);
    } else {
      this.previewRemoval();
    }

    this.application
      .getControllerForElementAndIdentifier(this.warningTarget, 'modal')
      .open(event);
  }

  previewMove(selected) {
    const missing = this.missingMembersValue[selected] || [];
    const destination = this.selectTarget.selectedOptions[0].text;

    this.moveBodyTarget.classList.remove('hidden');
    this.removeBodyTarget.classList.add('hidden');

    this.destinationNameTarget.textContent = destination;
    this.memberCountTarget.textContent = this.memberCountValue;

    this.renderMissingMembers(missing, destination);

    const moving = `Saving moves this fundraiser and all ${this.memberCountValue} team members to ${destination}.`;
    const stranded =
      missing.length > 0
        ? ` ${missing.length} of them are not connected to ${destination} and will not see this fundraiser until they connect to the fundraiser at ${destination}.`
        : '';

    this.showInlineWarning(`${moving}${stranded}`);
  }

  // no site means no IC listing: ic_site_id_eq never matches a null column
  previewRemoval() {
    this.moveBodyTarget.classList.add('hidden');
    this.removeBodyTarget.classList.remove('hidden');
    this.currentNameTarget.textContent = this.currentNameValue;

    this.showInlineWarning(
      `Saving removes this fundraiser from ${this.currentNameValue}. It will be hidden from Integral Context until you choose a site.`,
    );
  }

  renderMissingMembers(missing, destination) {
    this.membershipWarningTarget.classList.toggle(
      'hidden',
      missing.length === 0,
    );
    if (missing.length === 0) return;

    this.missingCountTarget.textContent = missing.length;
    this.missingDestinationNameTarget.textContent = destination;
    this.missingDestinationNameRepeatTarget.textContent = destination;

    this.missingListTarget.replaceChildren(
      ...missing.map((name) => {
        const item = document.createElement('li');
        item.textContent = name;
        return item;
      }),
    );
  }

  showInlineWarning(message) {
    this.inlineWarningTarget.textContent = message;
    this.inlineWarningTarget.classList.remove('hidden');
  }
}
